/**
 * Return a URL string without any GET parameters appended
 * @param url URL string, like `https://www.withpower.com/foo/bar?abc=def`
 * @returns URL string without any GET parameters `https://www.withpower.com/foo/bar`
 */
const getCanonicalUrl = (url: string) => url.split('?')[0]!

export default getCanonicalUrl
